/**
 *
 * @notice VisitaModalSlice to handle state of VisitaModal globally.
 *
 * @dev This module contains the reducer configuration and its initialization.
 * @dev Is the sucker wich contains features of this slice.
 *
 */

// Redux.
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// Axios.
import axios from "axios"
// gmapi.
import { API_KEY, caricaVisitaAPI } from "../../../../common/gmApi"
// cookie.
import { tkbox, getCookie } from "../../../../common/cookie"

/********************************************
 *                                          *
 * @notice AsyncThunk API(s) Implementation *
 *                                          *
 ********************************************/

/**
 *
 *  @dev Upload a new visita.
 *
 */
export const uploadVisita = createAsyncThunk(
    "visita/uploadVisita",
    async ({ organicoId, data, allegato, tipologiaVisita }, thunkAPI) => {
        try {
            var bodyFormData = new FormData()
            bodyFormData.append('allegato', allegato, allegato.name)

            const response = await axios.post(
                // url.
                caricaVisitaAPI,
                // body.
                bodyFormData,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        organicoId: organicoId,
                        data_visita: data,
                        tipologiaVisita: tipologiaVisita,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    //return console.log(response.data);
                    return response.data
                } else {
                    // else reject gmapi response error.
                    //console.error('Error "showEmployeeCourseDocById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "uploadVisita":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            // If something get wrong then reject the error.
            console.error('Error "uploadVisita":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

/*******************************************
 *                                         *
 * @notice createSlice implementation.     *
 *                                         *
 * @dev Create a "visitaModalSlice" feature. *
 * @dev UI views state controller.         *
 *                                         *
 *******************************************/
export const visitaModalSlice = createSlice({
    name: "visitaModal",
    initialState: {
        modalIsOpen: false,     // Modal is open or not.
        modalIsFetching: false, // AsyncThunk is calling an API.
        modalIsSuccess: false,  // AsyncThunk is success from API call.
        modalIsError: false,    // AsyncThunk is fail from API call.
        modalErrorMsg: "",      // Error message container.
    },
    reducers: {
        clearState: (state) => {
            state.modalIsError = false
            state.modalIsSuccess = false
            state.modalIsFetching = false

            return state
        },
        openModal: (state) => {
            state.modalIsOpen = true
        },
        closeModal: (state) => {
            state.modalIsOpen = false
        },
    },
    extraReducers: (builder) => {
        builder
            /**
             * @dev uploadVisita.
             */
            .addCase(uploadVisita.fulfilled, (state) => {
                state.modalIsFetching = false
                state.modalIsSuccess = true
            })
            .addCase(uploadVisita.pending, (state) => {
                state.modalIsFetching = true
            })
            .addCase(uploadVisita.rejected, (state, action) => {
                state.modalIsFetching = false
                state.modalIsError = true
                state.modalErrorMsg = action.payload
            })
    },
})

export const { clearState, openModal, closeModal } = visitaModalSlice.actions
export const visitaModalSelector = (state) => state.visitaModal